export default [
    'ar',
    'cs',
    'el',
    'en',
    'es',
    'fil',
    'hr',
    'hu',
    'id',
    'ja',
    'ko',
    'ms',
    'pl',
    'pt',
    'ru',
    'sk',
    'sl',
    'ta',
    'th',
    'vi',
    'zh-hans',
]
